import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MainPage from '../components/MainPage';
import getGroups from '../actions/api/group/getGroups';
import getOperators from '../actions/api/operators/getOperators';
import config from '../config';
import { GROUP_SUCCESS_API_GET_OPERATORS } from '../actions/actionTypes';
import getCompanyAssociatedTags from '../actions/api/tag/getCompanyAssociatedTags';

/**
 * グループ管理ページのライフサイクルを管理する
 * @returns
 */
const GroupContainer = () => {
  const { apiToken, isLogin, role, searchOptions, refreshPage } = useSelector(
    state => ({
      apiToken: state.main.apiToken,
      isLogin: state.main.isLogin,
      role: state.main.userInfo.role,
      searchOptions: state.group.searchOptions,
      refreshPage: state.group.refreshPage,
    }),
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: 'CLOSE_MENU' });
    dispatch({ type: 'OPEN_GROUP' });

    if (apiToken) {
      dispatch(getGroups(apiToken, searchOptions));
      dispatch(
        getCompanyAssociatedTags(
          apiToken,
          {
            depth: 0,
            isUsable: true,
            isDeleted: false,
          },
          'SUCCESS_API_GET_COMPANY_TAG_SET',
        ),
      );
    }

    // グループの担当者を取得（グループ更新ダイアログ、グループ追加ダイアログで表示）
    dispatch(
      getOperators(
        apiToken,
        {
          accountStatuses: config.searchAccountStatus.notDeleted,
          groupIds: null,
        },
        GROUP_SUCCESS_API_GET_OPERATORS,
      ),
    );
  }, [apiToken, dispatch, role, searchOptions, refreshPage]);

  // アンマウント時の処理
  useEffect(
    () => () => {
      dispatch({ type: 'RESET_GROUP_SEARCH_OPTIONS' });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return isLogin ? <MainPage /> : <Redirect to="/login" />;
};

export default GroupContainer;
